import { render } from "./commessaList.vue?vue&type=template&id=e89e6adc"
import script from "./commessaList.vue?vue&type=script&lang=js"
export * from "./commessaList.vue?vue&type=script&lang=js"

import "./commessaList.vue?vue&type=style&index=0&id=e89e6adc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__